import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RollNumber } from '../../../../../../shared/src/components/RollNumber';
import NumberBox from '../NumberBox';
import './Jackpot.css';
import NumberBoxSeparator from '../../../../../../shared/src/components/NumberBoxSeparator';
import classNames from 'classnames';
import { JackpotSourcesEnum } from '../../../../../../shared/src/enums/jackpot-sources.enum';

export const Jackpot = ({
    amount,
    currency,
    thumbnailSize,
    jackpotSource = JackpotSourcesEnum.PARI_PLAY,
    jackpotId,
}) => {
    const [isAnimationOn, setIsAnimationOn] = useState(true);
    const [isEffectTurnedOn, setIsEffectTurnedOn] = useState(false);
    const { intJackpotsBasic, intJackpotsPremium, jackpotTickerNg } =  useSelector((state) => state.app.config);
    // Prevent logic breaking when both keys configured
    const isBasicJackpotBehaviour = jackpotSource === JackpotSourcesEnum.PARI_PLAY
        && intJackpotsBasic && !intJackpotsPremium;
    const isPremiumJackpotBehaviour = (jackpotSource === JackpotSourcesEnum.PARI_PLAY && intJackpotsPremium)
        || (jackpotSource === JackpotSourcesEnum.NG_PJP && jackpotTickerNg);
    let digits = amount && amount.toFixed().toString().split('');

    const modeDuringAnimation = isAnimationOn ? 'premium' : 'basic';
    const animationTimeDurationMs = 1000;

    const wrapperClassName = classNames(
        'casino-thumbnail__jackpot',
        thumbnailSize,
        `jackpot-source--${jackpotSource}`,
    );
    const currencyClassName = classNames(
        'casino-jackpot-currency',
        thumbnailSize,
        {
            'basic': isBasicJackpotBehaviour || !isAnimationOn,
            'premium': isPremiumJackpotBehaviour && isAnimationOn,
        }
    );

    const wrapperProps = {};
    const jackpotIdParameterName = jackpotSource === JackpotSourcesEnum.NG_PJP
        ? 'data-progressive-jackpot-id'
        : 'data-jackpot-amount';
    wrapperProps[jackpotIdParameterName] = jackpotId;

    useEffect(() => {
        isAnimationOn && setTimeout(() => setIsAnimationOn(false), animationTimeDurationMs);
    }, [isAnimationOn]);

    useEffect(() => {
        setIsEffectTurnedOn(true);
    }, []);

    return <div
        {...wrapperProps}
        className={wrapperClassName}>
        <div className="casino-thumbnail__jackpot-amount">
            <span
                className={currencyClassName}
            >
                {currency}
            </span>
            {isPremiumJackpotBehaviour && digits.map((digit, index) =>
                NumberBoxSeparator(RollNumber, digits, index)({
                    index,
                    digit,
                    size: thumbnailSize,
                    mode: modeDuringAnimation,
                    separator: ',',
                    isAnimationToTop: true,
                    animationDurationSec: 1,
                    onAnimationStateChange: isEffectTurnedOn && setIsAnimationOn }))}
            {isBasicJackpotBehaviour && digits.map((digit, index) =>
                NumberBoxSeparator(NumberBox, digits, index)({
                    index, digit, size: thumbnailSize, mode: 'basic', separator: ',' }))}
        </div>
    </div>;
};
